<template>
  <div v-if="asyncDataStatus_ready">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.groups.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter = ''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({ name: 'MyCompanyGroupsNew' })"
        >
          Nova grupa
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.groups.length">
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Ime
                </th>
                <th class="text-left">
                  Stopnja
                </th>
                <th class="text-left  hidden-xs-only ">
                  Tip
                </th>

                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="group in filteredGroups" :key="group.id">
                <td>{{ group.name }}</td>
                <td>{{ group.tax_level_value }}%</td>
                <td class="hidden-xs-only">
                  {{ group.tax_type_name }}
                </td>

                <td class="text-right">
                  <ButtonActionEdit
                    @click="
                      $router.push({
                        name: 'MyCompanyGroupsEdit',
                        params: { id: group.id }
                      })
                    "
                  />
                  <ButtonActionDelete
                    @click="
                      showDeleteGroupModal = true;
                      deleteGroup = group;
                    "
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove grupe uporabite gumb desno
          zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje grupe"
      text="Ali ste prepričani, da želite izbrisati grupo? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteGroupModal"
      @confirmed="remove(deleteGroup)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'

export default {
  components: {
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete
  },
  mixins: [asyncDataStatus],
  data () {
    return {
      filter: '',
      showDeleteGroupModal: false,
      deleteGroup: null
    }
  },
  computed: {
    groups () {
      return objectToArray(this.$store.state.groups.items)
    },
    filteredGroups () {
      return this.groups.filter(item =>
        siIncludes({ haystack: `${item.name}`, needle: this.filter })
      )
    }
  },
  methods: {
    ...mapActions('groups', ['loadItems', 'deleteItem']),
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    loadItems(this)
  }
}
</script>
